import { inject, Service } from "@angular/core";

import { CommonKpiModelType, GovProjectMilestone, GovProjectTask, GovProjectTrack, MainResponseModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class GovProjectsApiService {
  private readonly _mainService = inject(MainService);

  public getTrackById(apiPrefix: string, id: number) {
    return this._mainService.sendRequest<MainResponseModel<GovProjectTrack>>({
      method: "GET",
      url: `${apiPrefix}/getTrackById?id=${id}`,
    });
  }

  public saveTrack(apiPrefix: string, isEdit: boolean, track: GovProjectTrack) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${apiPrefix}/${isEdit ? "updateTrack" : "createTrack"}`,
      data: track,
    });
  }

  public getMilestoneById(apiPrefix: string, id: number) {
    return this._mainService.sendRequest<MainResponseModel<GovProjectMilestone>>({
      method: "GET",
      url: `${apiPrefix}/getMilestoneById?id=${id}`,
    });
  }

  public updateMilestone(apiPrefix: string, milestone: GovProjectMilestone) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${apiPrefix}/updateMilestone`,
      data: milestone,
    });
  }

  public getTaskById(apiPrefix: string, id: number) {
    return this._mainService.sendRequest<MainResponseModel<GovProjectTask>>({
      method: "GET",
      url: `${apiPrefix}/getTaskById?id=${id}`,
    });
  }

  public updateTask(apiPrefix: string, task: GovProjectTask) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${apiPrefix}/updateTask`,
      data: task,
    });
  }

  public deleteTrack(apiPrefix: string, id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `${apiPrefix}/deleteTrack?id=${id}`,
    });
  }

  public getNationalKpiByTrackId(apiPrefix: string, trackId: number) {
    return this._mainService.sendRequest<MainResponseModel<CommonKpiModelType>>({
      method: "GET",
      url: `${apiPrefix}/getNationalKpiByTrackId?trackId=${trackId}`,
    });
  }

  public getTracks(apiPrefix: string) {
    return this._mainService.sendRequest<MainResponseModel<GovProjectTrack[]>>({
      method: "GET",
      url: `${apiPrefix}/getTracks`,
    });
  }

  public getAllMilestones(apiPrefix: string) {
    return this._mainService.sendRequest<MainResponseModel<GovProjectMilestone[]>>({
      method: "POST",
      url: `${apiPrefix}/getAllMilestones?offset=0&limit=100000`,
      data: {},
    });
  }
}
